import axios from "@/helpers/axios";

const base_url = process.env.VUE_APP_API_BASEURL;

async function list(params) {

  return axios.get(`${base_url}oem-customers`, { params }).then((response) => {

    return response.data;
  });
}

async function show(oemCustomer) {
  return axios.get(`${base_url}oem-customers/${oemCustomer.id}`).then((response) => {
    return response.data;
  });
}

async function add(oemCustomer) {
  return axios.post(`${base_url}oem-customers`, oemCustomer).then((response) => {
    return response.data;
  });
}

async function update(oemCustomer) {
  return axios.put(`${base_url}oem-customers/${oemCustomer.id}`, oemCustomer).then((response) => {
    return response.data;
  });
}

async function destroy(oemCustomer) {

  return axios.delete_method(`${base_url}oem-customers/${oemCustomer.id}`).then((response) => {
    return response.data;
  });
}

export default {
  list,
  show,
  add,
  update,
  destroy,
};
